import { css } from '@emotion/react';
import { theme } from '../../../design-system/theme/theme';

export const separatorStyle = css`
  color: ${theme.color.textMuted};
`;

/* 검색 입력 14rem — 시안 w-56 스냅. */
export const searchStyle = css`
  input {
    width: 14rem;
    box-sizing: border-box;
  }
`;
